import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    aiPoweredDescription: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Description of AI-powered search shown in the footer of AI results */
            aiPoweredDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchNlpResultsFooter.aiPoweredDescription?c=1bkoris4jpuse", defaultMessage: "AI search surfaces results that go beyond keywords." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
